import React, { useState, useEffect, useCallback } from 'react'

import {
	Button,
	Checkbox,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	FormControl,
	FormHelperText,
	InputAdornment,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	Snackbar,
	TextField,
	Typography
} from '@material-ui/core'
import { debounce } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useSelector, useDispatch } from 'react-redux'

import { DeletableChip } from '../../components/Misc/DeletableChip'

import { CustomAddOnOccurences } from '../Addons/customAddonOccurences'

import MuiAlert from '@material-ui/lab/Alert'

import { postAddOns } from '../../actions/addons/addons.actions'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px',
			minWidth: '700px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '274px !important'
		}
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '7px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	}
}))


const types = ['Indoor Play', 'Outdoor Play', 'Kennel Room', 'Grooming', 'Vet', 'Other']

const AreaDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [mapped_areas, setMappedAreas] = useState([])

	const sizes = ['xl', 'l', 'm', 's', 'xs']

	const { isShown, setIsShown, area, updateArea, save, areas, kennels, setDelete } = props

	return (
		<Dialog
			open={isShown}
			width="md"
			onClose={() => setIsShown()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle>{area?._id ? 'Edit Area' : 'Add New Area'}</DialogTitle>
			<DialogContent>
				<div className={classes.formWrapper}>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Name"
							value={area.name}
							style={{ width: '48%', marginBottom: 16 }}
							required
							helperText={`${area?.name?.length || 0} / 25`}
							error={area?.name?.length > 25}
							onChange={(e) => updateArea('name', e.target.value)}
							variant="filled"
						/>
						<TextField
							label="Abbreviation (Max 10 characters)"
							error={area.abbreviation?.length > 10}
							value={area.abbreviation}
							style={{ width: '48%', marginBottom: 16 }}
							onChange={(e) => {
								updateArea('abbreviation', e.target.value)
							}}
							variant="filled"
						/>
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							select
							label="Type"
							value={area.type}
							required
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							onChange={(e) => updateArea('type', e.target.value)}
							variant="filled">
							{types.map(s => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>{s}</MenuItem>
							))}
						</TextField>

						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="breed"
							style={{ width: '48%' }}
							className={classes.autoComplete}
							options={sizes}
							value={area?.size_restrictions || []}
							onChange={(e, v) => {
								updateArea('size_restrictions', v)
							}}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderTags={(selected) =>
								selected.filter(Boolean).map(value => {
									return (
										<DeletableChip
											key={value}
											label={value}
											{...{
												onDelete: () => {
													updateArea('size_restrictions', selected.filter(s => s != value))
												}
											}}
										/>
									)
								})
							}
							getOptionLabel={(option) => option}
							renderOption={(option, { selected }) => {
								let isSelected = area?.size_restrictions?.includes(option)
								return (
									<React.Fragment>
										<Checkbox checked={isSelected ? true : false} />
										<ListItemText primary={option} />
									</React.Fragment>
								)
							}}
							renderInput={(params) => (
								<TextField {...params} variant="filled" required fullWidth label="Size Restrictions" />
							)} />
					</div>

				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={save} color="secondary" disabled={!area.name || !area.type || area.name.length > 25}>
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => setIsShown()} color="secondary">
					CANCEL
				</Button>
				{area?._id &&
					<Button variant="text"
						onClick={() => {
							setDelete('area')
						}}
						style={{
							fontFamily: 'Nunito',
							color: '#D02C2C',
							fontSize: '14px',
							lineHeight: '19px',
							marginLeft: 'auto',
							textTransform: 'uppercase',
							fontWeight: '800'
						}}>
						Delete Area
					</Button>
				}
			</DialogActions>
		</Dialog>
	)
}

export default AreaDialog
